export default "__VITE_ASSET__DUMac00H__"